<script>
import Multiselect from 'vue-multiselect'
import UploadFile from '@components/upload-file'

export default {

    components: { Multiselect, UploadFile },

    props: {

    },

    data() {
        return {
            trackBy: 'id',
            method: null,
            initMethod: [],
            method_options: [
                { id:'get',         name:'GET' },
                { id:'post-data',   name:'POST-data' },
                { id:'post-json',   name:'POST-json' },
                { id:'patch-json',  name:'PATCH-json' },
                { id:'put-json',    name:'PUT-json' },
                { id:'delete-json', name:'DELETE-json' },
            ],
        }
    },

    watch: {
        initMethod: {
            immediate: true,
            handler(values) {
                this.method = this.method_options.filter(x => values.includes(x[this.trackBy]));
                this.method = this.method[0];
            }
        },
        method: {
            immediate: true,
            handler(values) {
                if(this.method){
                    this.$parent.http_request_params.method = this.method.id ? this.method.id : null
                } else {
                    this.$parent.http_request_params.method = null
                }
            }
        },
    },

    computed: {

    },

    async mounted() {
        if(this.$parent.params.http_request_params && this.$parent.params.http_request_params.method) {
            this.initMethod = [this.$parent.params.http_request_params.method];
        }
    },

    methods: {

    }
}
</script>

<template>
    <div>

        <b-form-group
            label="URL запроса"
            label-for="url"
        >
            <b-form-input
                id="url"
                v-model="$parent.http_request_params.url"
                placeholder="https://"
            ></b-form-input>
        </b-form-group>

        <b-form-group
            label="Тип запроса"
            label-for="status"
        >
            <multiselect
                id="status"
                v-model="method"
                :options="method_options"
                placeholder="Выберите из списка"
                selectLabel="Нажмите, чтобы выбрать"
                deselectLabel="Нажмите, снять выделение"
                label="name"
                :track-by="trackBy"
            ></multiselect>
        </b-form-group>

        <b-form-group
            label="Заголовок запроса"
            label-for="header"
        >
            <b-form-textarea
                id="header"
                v-model="$parent.http_request_params.header"
                placeholder='{"Content-Type": "application/json; charset=utf-8"}'
                rows="4"
            ></b-form-textarea>
        </b-form-group>

        <b-form-group
            label="JSON параметры"
            label-for="data"
        >
            <b-form-textarea
                id="data"
                v-model="$parent.http_request_params.data"
                placeholder='{"var1" : $var1}'
                rows="4"
            ></b-form-textarea>
        </b-form-group>

        <b-form-group
            label="Максимальное время запроса (сек)"
            label-for="timeout"
        >
            <b-form-input
                id="timeout"
                v-model="$parent.http_request_params.timeout"
                placeholder=""
            ></b-form-input>
        </b-form-group>

        <div class="row">
            <div class="col-sm-12 col-xl-12">
                <b-form-checkbox v-model="$parent.http_request_params.wait_response" name="http_request_params_wait_response" style="margin-bottom: 15px" switch>
                    Ждать ответ
                </b-form-checkbox>
            </div>
        </div>

        <b-form-group
            v-if="$parent.http_request_params.wait_response"
            label="Сохранить результаты ответа"
            label-for="variables"
        >
            <b-form-textarea
                id="variables"
                v-model="$parent.http_request_params.variables"
                placeholder="$var1 = $response['var1']"
                rows="4"
            ></b-form-textarea>
        </b-form-group>

    </div>
</template>
